<template>
  <div class="about">
    <Headers></Headers>
    <div class="banner"
         style="background: url(/static/about/banner1.jpg)">
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">关于我们</div>
          <div class="entitle">About us</div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="nav">
      <div class="container">
        <p @click="iscidbtn(item.id)"
           :class="cate_id === item.id ? 'on' : ''"
           v-for="(item, index) in navlist"
           :key="index">
          {{ item.title }}
        </p>
      </div>
    </div>
    <div class="bottom">
      <div class="container">
        <div class="conbox"
             v-if="con.contents">
          <div class="title">{{ con.title }}</div>
          <div class="con"
               v-html="con.contents"></div>
        </div>
        <unllimg v-else></unllimg>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import unllimg from '@/components/unllimg/unllimg.vue'
import service from './about'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'about',
  mixins: [setmeta],
  data () {
    return {
      id: 2,
      cate_id: '',
      navlist: [],
      con: ''
    }
  },
  components: {
    Headers,
    Footer,
    unllimg
  },
  watch: {
    cate_id () {
      service.getArtivleList(this)
    }
  },
  methods: {
    iscidbtn (cateid) {
      this.cate_id = cateid
    }
  },
  created () {
    this.setMetaConfig({
      web_title: `关于我们-${this.$env.TITLE}`
    })
    service.getColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import './about';
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue